export default "__VITE_ASSET__CQTpfpT9__"